import { CheckStackInIssuesRequest, YardIssuesApi } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class YardIssueService {
  private readonly httpClient = createApiClient(YardIssuesApi)

  async getYardIssues() {
    const { data } = await this.httpClient.getYardIssues()

    return data
  }

  async checkStackInIssues(request: CheckStackInIssuesRequest) {
    const { data } = await this.httpClient.checkStackInIssues(request)

    return data
  }
}

export const yardIssueService = new YardIssueService()
